import { type ReactNode, useState } from 'react';
import { isTvAcceptanceEnabled, normalizeInset, readTvInset } from '../../lib/tvAcceptance';

/** Scale the existing canvas uniformly; do not change timer geometry or shared venue settings. */
export function TvSafeArea({
  children,
  inset,
  screenInset = 0,
}: {
  children: ReactNode;
  inset?: number;
  screenInset?: number;
}) {
  const [saved] = useState(() => (isTvAcceptanceEnabled ? readTvInset() : 0));
  const screenValue =
    typeof screenInset === 'number' &&
    Number.isFinite(screenInset) &&
    screenInset >= 0 &&
    screenInset <= 5 &&
    Number.isInteger(screenInset * 2)
      ? screenInset
      : 0;
  const value = Math.min(
    10,
    screenValue + (isTvAcceptanceEnabled ? normalizeInset(inset ?? saved) : 0),
  );
  return (
    <div className="h-screen w-screen overflow-hidden bg-black" data-tv-safe-area={value}>
      <div
        data-tv-canvas
        style={{
          height: '100%',
          width: '100%',
          transform: value ? `scale(${1 - value / 50})` : undefined,
          transformOrigin: 'center center',
        }}
      >
        {children}
      </div>
    </div>
  );
}
